module.exports = __webpack_public_path__ + "img/ExcelIcon256x256.4530ecfa.png";